import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import { fromHttpPromise } from 'pulse/adapters';
export const defaultPropertyGroupsResolver = fromHttpPromise('propertyGroupsResolver', async (httpClient, {
  objectTypeId
}) => {
  const client = await getFrameworkDataSchemasClient({
    httpClient: httpClient
  });
  return client.properties.getGroups({
    frameworkTypeIdentifier: objectTypeId,
    query: {
      // Always pass `true`. We can derive the result of passing `false` from the result of passing `true`, but not the inverse.
      showHighlySensitiveProperties: true
    },
    refetch: true
  });
});